// popup click event by TT
if(document.getElementById("get-one-free")) {
    document.getElementById("get-one-free").addEventListener("click", ()=>{
        document.querySelector('.mr-get-one-free').style.display = "block";
    });
}

if (document.getElementById("guarantee-policy")){
    document.getElementById("guarantee-policy").addEventListener("click", ()=>{
        document.querySelector('.mr-confort-100').style.display = "block";
    });
}

if (document.getElementById("giveaway")){
    document.getElementById("giveaway").addEventListener( "click", ()=> {
        document.querySelector('.underwear-giveaway').style.display = "block";
    });
}

if(document.getElementById("size-chart-js")){
    document.getElementById("size-chart-js").addEventListener("click", ()=>{
        document.querySelector('.mr-size-guide-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if(document.getElementById("outOfStock")){
    document.getElementById("outOfStock").addEventListener("click", ()=>{
        document.querySelector('.out-of-stock').style.display = "block";
    });
}

if(document.getElementsByClassName("cotton-series-long-js")[0]){
    document.getElementsByClassName("cotton-series-long-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-cotton-series-long-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}
if(document.getElementsByClassName("cotton-series-brief-js")[0]){
    document.getElementsByClassName("cotton-series-brief-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-cotton-series-brief-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}
if(document.getElementsByClassName("cotton-series-short-js")[0]){
    document.getElementsByClassName("cotton-series-short-js")[0].addEventListener("click", (e)=>{
        e.preventDefault();
        document.querySelector('.mr-cotton-series-short-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if(document.getElementsByClassName("premium-fabrics")[0]){
    document.getElementsByClassName("premium-fabrics")[0].addEventListener("click", ()=>{
        document.querySelector('.premium-fabrics-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if(document.getElementsByClassName("game-changing-popup")[0]){
    document.getElementsByClassName("game-changing-popup")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-sweat-series-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}
if(document.getElementsByClassName("collection-hero__sub-title")[0]){
    document.getElementsByClassName("collection-hero__sub-title")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-game-template-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if(document.getElementsByClassName("sweat-series-js")[0]){
    document.getElementsByClassName("sweat-series-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-sweat-series-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if(document.getElementsByClassName("bamboo-series-js")[0]){
    document.getElementsByClassName("bamboo-series-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-bamboo-series-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if (document.getElementsByClassName("sweat-series-long-js")[0] || document.getElementsByClassName("bamboo-series-long-js")[0]){
    document.getElementsByClassName("sweat-series-long-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-sweat-series-long-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
    document.getElementsByClassName("bamboo-series-long-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-bamboo-series-long-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if( typeof document.getElementsByClassName("sweat-series-brief-popup-js")[0] !== 'undefined' ||  typeof document.getElementsByClassName("bamboo-series-brief-popup-js")[0] !== 'undefined'  ){
    document.getElementsByClassName("sweat-series-brief-popup-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-sweat-series-brief-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
    document.getElementsByClassName("bamboo-series-brief-popup-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-bamboo-series-brief-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}

if( typeof document.getElementsByClassName("swim-brief-popup-js")[0] !== 'undefined' ){
    document.getElementsByClassName("swim-brief-popup-js")[0].addEventListener("click", ()=>{
        document.querySelector('.mr-swim-brief-popup').style.display = "block";
        document.body.classList.add('overflow-hidden')
    });
}


// Overlay Close
document.querySelectorAll('.overlay-js').forEach((el) => {
    el.addEventListener('click', (event) => {
        console.log(event.currentTarget);
        el.parentElement.style.display = "none";
        document.body.classList.remove('overflow-hidden');
    });
    el.parentElement.addEventListener('keyup', onKeyUpEscape);

});

// Close
document.querySelectorAll('.close').forEach((close) => {
    close.addEventListener('click', (event) => {
        event.currentTarget.parentElement.parentElement.style.display = "none"
        document.body.classList.remove('overflow-hidden')
    });
    close.parentElement.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// select variants
var variantRadios = document.getElementById("variant-radios");
if( variantRadios  !== null ) {
    variantRadios.addEventListener("click", (el) => {
        document.getElementById("js-select-variant").style.display = "none";
        variantRadios.classList.add("variant-radios-checked");
    })

    document.getElementById("js-select-variant").addEventListener("click", ()=>{
        variantRadios.classList.add("has-active");
        document.getElementById("product-drawer-js").classList.add("has-active");
    })
}

// Product drawer Hide
var sizeChartProductDrawer = document.getElementById('size-chart-product-drawer');
if ( sizeChartProductDrawer ){
    sizeChartProductDrawer.addEventListener("click", ()=>{
        document.querySelector('.mr-size-guide-popup').style.display = "block";

        var productID = document.querySelector('#product-drawer-js');
        if (productID.classList.contains("has-active")){
            productID.classList.remove("has-active");
        }
    });

    function productDrawerHide(){
        document.getElementById("product-drawer-js").classList.remove("has-active");
        document.getElementById('cart-icon-bubble').click();
    }
    document.getElementById("product-drawer-bg-js").addEventListener("click", productDrawerHide);
    document.getElementById("product-drawer__close-js").addEventListener("click", productDrawerHide);
}

// review click
var junip = document.querySelector('[id^="shopify-block-"]');
if(junip) {
    junip.addEventListener('click', (event) => {
        event.preventDefault();
        var reviewOpenID = document.getElementById("review-open-fix");
        reviewOpenID.children[0].setAttribute("open","open");
        var getHeight = window.outerHeight;
        document.documentElement.scrollTop  = getHeight + 250
    });
}

// product type slider
var productTypeSlider = new Swiper('.mr-product-type-wrap', {
    slidesPerGroup: 6,
    slidesPerView: 6,
    // grid: {
    //     rows: 2
    // },
    breakpoints: {
        990: {
            slidesPerGroup: 6,
            slidesPerView: 6,
        },
        1024: {
            slidesPerGroup: 10,
            slidesPerView: 10,
            grid: {
                rows: 1
            }
        },
        2000: {
            slidesPerGroup: 10,
            slidesPerView: 10,
        },
    },
    freeMode: true,
    spaceBetween: 3,
    speed: 500,
    freeModeMomentumVelocityRatio: 0.8,
    freeModeMomentumBounce: false, // Remove this when upgraded to >= v6.3.4
    lazyLoad: true,
    navigation: {
        nextEl: '.wb-fashion-color-switch__nav-next',
        prevEl: '.wb-fashion-color-switch__nav-prev',
        disabledClass: 'wb-fashion-color-switch__nav--disabled',
        hiddenClass: 'wb-fashion-color-switch__nav--disabled'
    },
    roundLengths: true, //prevent blurry text
    mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        invert: true
    }
});

// check out of stock
const inputs = document.querySelectorAll('input');
let productUnAvailable = false;
for (let i = 0; i < inputs.length; i++) {
    if (inputs[i].classList.contains('product-disabled')) {
        productUnAvailable = true;
    }
}
if (productUnAvailable === true ) {
    console.log('disable true')
    document.querySelector('.product-form-color').classList.add('has-product-outofstock')
}

// product type event
/*
const shortSeries = document.getElementById("short-series-js"),
    longSeries = document.getElementById("long-series-js"),
    longSeriesWrap = document.getElementById("long-series-wrap"),
    shortSeriesWrap = document.getElementById("short-series-wrap");

if ( shortSeries != null || longSeries != null || longSeriesWrap != null || shortSeriesWrap != null ){
  shortSeries.addEventListener("click", (event)=> {
    longSeries.classList.remove("has-active");
    event.target.classList.add("has-active");
    longSeriesWrap.style.display = "none";
    shortSeriesWrap.style.display = "block";
  });

  longSeries.addEventListener("click", (event)=> {
    shortSeries.classList.remove("has-active");
    event.target.classList.add("has-active");
    longSeriesWrap.style.display = "block";
    shortSeriesWrap.style.display = "none";
  });
}
*/

// Popup MEN LOUNGEWEAR TOP SIZE GUIDE
const sizeGuideInc = document.getElementById("size-guide-inc"),
    sizeGuideCm = document.getElementById("size-guide-cm");
if ( sizeGuideInc != null || sizeGuideCm != null ){
    sizeGuideInc.addEventListener("click", (el)=>{
        sizeGuideCm.classList.remove("active");
        el.target.classList.add("active");
        document.querySelector('.size-guide-cm').style.display = "none";
        document.querySelector('.size-guide-inc').style.display = "block";
    });
    sizeGuideCm.addEventListener("click", (el)=>{
        sizeGuideInc.classList.remove("active");
        el.target.classList.add("active");
        document.querySelector('.size-guide-inc').style.display = "none";
        document.querySelector('.size-guide-cm').style.display = "block";
    });
}



if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');

                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButton.querySelector('span').classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove('loading');
                        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                        if (document.querySelector('.free-gift-products--inner').classList.contains('is--open')){
                            document.querySelector('.giftClose').click();
                        }
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}
// Product drawer
if (!customElements.get('product-drawer-form')) {
    customElements.define(
        'product-drawer-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');

                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();
                this.submitButton.setAttribute('aria-disabled', true);
                this.addSuccess = this.querySelector(".add-success");
                this.addSuccess.classList.add("add-success--adding");
                //this.submitButton.classList.add('loading');
                // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButton.querySelector('span').classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-drawer-form', productVariantId: formData.get('id'), cartData: response });
                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.addSuccess.classList.remove("add-success--adding");
                            this.addSuccess.classList.add("add-success--added");
                            this.cart.renderContentsMobileDrawer(response);
                            setTimeout( () => {
                                this.addSuccess.classList.remove("add-success--added");
                            }, 1000);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        //this.submitButton.classList.remove('loading');
                        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                        //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}